import { PaperGenerationImport } from './Import'
const {
    RoutesMap, QuestionList, AddQuestion, UpdateQuestion,
    QuestionBankList, AddQuestionBank, UpdateQuestionBank, QuestionBankDetails,
    ExamList, AddExam, UpdateExam, ExamDetails,
    ExamQuestionList, AddExamQuestion, TestDesignerList, AddTestDesigner, UpdateTestDesigner, TestDesignerDetails,
    ExamInvitationList, AddExamInvitation
} = PaperGenerationImport

const PaperGenerationRoute = () => {
    return [
        {
            path: RoutesMap.QUESTION_LIST.path,
            element: <QuestionList />
        },
        {
            path: RoutesMap.ADD_QUESTION.path,
            element: <AddQuestion />
        },
        {
            path: RoutesMap.UPDATE_QUESTION.path,
            element: <UpdateQuestion />
        },
        {
            path: RoutesMap.QUESTION_BANK_LIST.path,
            element: <QuestionBankList />
        },
        {
            path: RoutesMap.ADD_QUESTION_BANK.path,
            element: <AddQuestionBank />
        },
        {
            path: RoutesMap.UPDATE_QUESTION_BANK.path,
            element: <UpdateQuestionBank />
        },
        {
            path: RoutesMap.QUESTION_BANK_DETAILS.path,
            element: <QuestionBankDetails />
        },
        {
            path: RoutesMap.EXAM_LIST.path,
            element: <ExamList />
        },
        {
            path: RoutesMap.ADD_EXAM.path,
            element: <AddExam />
        },
        {
            path: RoutesMap.UPDATE_EXAM.path,
            element: <UpdateExam />
        },
        {
            path: RoutesMap.EXAM_DETAILS.path,
            element: <ExamDetails />
        },
        {
            path: RoutesMap.EXAM_QUESTION_LIST.path,
            element: <ExamQuestionList />
        },
        {
            path: RoutesMap.ADD_EXAM_QUESTION.path,
            element: <AddExamQuestion />
        },
        {
            path: RoutesMap.TEST_DESIGNER_LIST.path,
            element: <TestDesignerList />
        },
        {
            path: RoutesMap.ADD_TEST_DESIGNER.path,
            element: <AddTestDesigner />
        },
        {
            path: RoutesMap.UPDATE_TEST_DESIGNER.path,
            element: <UpdateTestDesigner />
        },
        {
            path: RoutesMap.TEST_DESIGNER_DETAILS.path,
            element: <TestDesignerDetails />
        },
        {
            path: RoutesMap.EXAM_INVITATION_LIST.path,
            element: <ExamInvitationList />
        },
        {
            path: RoutesMap.ADD_EXAM_INVITATION.path,
            element: <AddExamInvitation />
        },
    ]
}

export default PaperGenerationRoute
